"use client";

import * as React from "react";
import { usePermission } from "./use-permission";
import type { Permission } from "./permissions";

interface CanProps {
  perm: Permission;
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

/** Renders children only if the active user holds `perm`. */
export function Can({ perm, children, fallback = null }: CanProps) {
  const allowed = usePermission(perm);
  return <>{allowed ? children : fallback}</>;
}
